import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config";
import { showSuccess } from "../../utils/dialog";
import "../../Styles/AccessibilityStndCustmer.css";
import talentLogo from "../../assets/talentlogo2.png";

const AdditionalInfo = () => {
  const navigate = useNavigate();
  const itemId = "additional-info";
  const fieldOrder = ["talentInfo"]; // single field on this page
  const [formData, setFormData] = useState(() => {
    const accountId = localStorage.getItem("accountId");
    const saved = localStorage.getItem(`form_${accountId}_${itemId}`);
    const initial = saved ? JSON.parse(saved) : {};
    return fieldOrder.reduce((acc, f) => {
      acc[f] = initial[f] ?? "";
      return acc;
    }, {});
  });

  useEffect(() => {
    const accountId = localStorage.getItem("accountId");
    const saved = localStorage.getItem(`form_${accountId}_${itemId}`);
    if (saved) {
      const raw = JSON.parse(saved);
      const normalized = fieldOrder.reduce((acc, f) => {
        acc[f] = raw[f] ?? "";
        return acc;
      }, {});
      setFormData(normalized);
    }
  }, []);

  useEffect(() => {
    const values = fieldOrder.map((f) => (formData[f] ?? "").toString().trim());
    const allEmpty = values.every((v) => v.length === 0);
    const allFilled = values.every((v) => v.length !== 0);
    const status = allEmpty
      ? "incomplete"
      : allFilled
      ? "complete"
      : "in-progress";

    // Update localStorage
    const accountId = localStorage.getItem("accountId");
    localStorage.setItem(`status_${accountId}_${itemId}`, status);
    localStorage.setItem(
      `form_${accountId}_${itemId}`,
      JSON.stringify(formData)
    );

    // Sync status to backend for real-time updates (form data stays in localStorage)
    if (accountId && status !== "incomplete") {
      axios
        .post(`${BASE_URL}/api/registration/${accountId}/status/${itemId}`, {
          status,
          formData: {}, // Don't send form data, just status
        })
        .catch((err) => console.error("Failed to sync status:", err));
    }
  }, [formData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const accountId = localStorage.getItem("accountId");
    localStorage.setItem(
      `form_${accountId}_${itemId}`,
      JSON.stringify(formData)
    );
    const values = fieldOrder.map((f) => (formData[f] ?? "").toString().trim());
    const allEmpty = values.every((v) => v.length === 0);
    const allFilled = values.every((v) => v.length !== 0);
    const newStatus = allEmpty
      ? "incomplete"
      : allFilled
      ? "complete"
      : "in-progress";
    const payload = { status: newStatus, formData };
    if (accountId && newStatus === "complete") {
      axios
        .post(
          `${BASE_URL}/api/registration/${accountId}/items/${itemId}/complete`,
          payload
        )
        .catch((err) => console.error("Failed to save additional info:", err))
        .finally(() => {
          axios
            .post(
              `${BASE_URL}/api/registration/${accountId}/status/${itemId}`,
              { status: newStatus, formData: {} }
            )
            .catch(() => {});
          showSuccess("Form completed successfully!");
          navigate("/register");
        });
    } else {
      navigate("/register");
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };
  const handleBack = () => {
    navigate("/register");
  };
  return (
    <div className="accessibility-form-page">
      <div className="form-container">
        <div className="form-card">
          <header
            className="form-card-header"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={talentLogo}
              alt="Talent Employment Inc."
              style={{ height: 64, marginBottom: 10 }}
            />
            <h2 className="form-title" style={{ textAlign: "center" }}>
              Additional Info
            </h2>
          </header>

          <form onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="talentInfo">
                Please tell us how you found out about Talent?*
              </label>
              <input
                id="talentInfo"
                type="text"
                value={formData.talentInfo}
                onChange={(e) =>
                  handleInputChange("talentInfo", e.target.value)
                }
                required
              />
            </div>

            <div className="form-buttons">
              <button type="button" onClick={handleBack}>
                Back
              </button>
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdditionalInfo;
